import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const TilesInner = styled.div<{
  $useCase?: string
  $twoTiles?: boolean
}>`
  ${({ theme, $useCase, $twoTiles }) => {
    let imageContainerSize = ``

    if ($useCase === 'Icon') {
      imageContainerSize = `
        .Tiles__Image-Container {
          width: 32px;
          height: 32px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      `
    } else {
      imageContainerSize = `
        .Tiles__Image-Container {
          position: relative;
          height: 170px;
          width: 100%;

          img {
            width: 224px;
            height: 112px;
            object-fit: contain;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      `
    }

    return `
      ${imageContainerSize}
      display: flex;
      width: calc(100% + 24px);
      margin: -12px;
      flex-wrap: wrap;
      ${$twoTiles ? 'justify-content: center;' : ''}

      ${theme.breakpoints.down('sm')} {
        width: calc(100% + 16px);
        margin: -8px;
      }

      ${theme.breakpoints.down('xs')} {
        align-items: center;
        flex-direction: column;
      }

      &.Tiles__Item--ThreeCol .Tiles__Item {
        width: 384px;
        ${theme.breakpoints.down('md')} {
          width: 304px;
        }
      }

      &.Tiles__Item--FourCol .Tiles__Item {
        width: 282px;
        ${theme.breakpoints.down('md')} {
          width: 222px;
        }
      }

      &.Tiles__Item--ThreeCol .Tiles__Item,
      &.Tiles__Item--FourCol .Tiles__Item {
        ${theme.breakpoints.down('sm')} {
          width: 360px;
        }

        ${theme.breakpoints.down('xs')} {
          max-width: 328px;
          width: auto;
        }
      }

      .Tiles__Item {
        padding: 24px;
        margin: 12px;
        background: ${theme.webMktNewPalette.white};
        box-sizing: border-box;
        height: calc(100% - 24px);
        a.CTA{z-index:2}

        .Tiles__Item-Title {
          
          margin-top: 21px;
          margin-bottom: 7px;
        }

        ${theme.breakpoints.down('sm')} {
          margin: 8px;
        }

        .Tiles__Item-Text, .Tiles__Item-RFT-Text {
          color: ${theme.webMktNewPalette.deepBlue[55]};
          margin: 24px 0;
          
          ${theme.breakpoints.down('md')} {
            margin: 16px 0;
          }
        }

        p:first-of-type {
          margin-top: 21px;
        }

        > *:first-child {
          margin-top: 0 !important;
        }
      }

      .Tiles__Orange_Theme {
        background: ${theme.webMktNewPalette.orange[50]};
        padding-bottom: 24px;

        .Tiles__Item-Title, .Tiles__Item-Text, .Tiles__Item-RFT-Text * { 
          color: ${theme.webMktNewPalette.white}; 
        }
      }

      .inline-formatter {
        display: inline;
      }

      .block-formatter {
        display: block;
      }

      .Tiles__Item-FinePrint {
        display: inline;
        margin-left: 4px;

        ${theme.breakpoints.up('lg')} {
          color: ${theme.webMktNewPalette.black};
          
        }
      }

      .Tiles__Item-Formatted__Title_Last {
        display: inline-block;
      }

      .Tiles__CTA1 {
        padding: 12px 12px 12px 16px;
        margin-top: auto;
        z-index:1;

        ${theme.breakpoints.down('md')} {
          margin-top: 0;
        }

        .CTA__Arrow-Container {
          width: 16px;
          height: 16px;
          right: -16px;
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }

      .Tiles__CTA2 {
        color: ${theme.webMktNewPalette.white};
      
        margin-top: 24px;

        .CTA__Arrow-Container path#ArrowPath {
          transform: scale(0.8) translate(-3px,3px) ;
          fill: ${theme.webMktNewPalette.white};
        }
      }

      .Tiles__CTA2:hover {
        color: ${theme.webMktNewPalette.white};
        .CTA__Arrow-Container path#ArrowPath {
          fill: ${theme.webMktNewPalette.white};
        }
      }

      .Tiles__Card-Link--Pricing {
        .Tiles__Item-Title {
          min-height: 48px;
          margin-bottom: 0;

          ${theme.breakpoints.down('md')} {
            min-height: 72px;
          }

          ${theme.breakpoints.down('sm')} {
            min-height: 48px;
          }
        }

        .Tiles__Item-Text {
            ${theme.breakpoints.down('md')} {
              min-height: 96px;
            }

            ${theme.breakpoints.down('sm')} {
              min-height: 48px;
            }
          }

        .Tiles__Orange_Theme {
          .Tiles__Item-Title {
            ${theme.breakpoints.down('sm')} {
              min-height: 48px;
            }

            ${theme.breakpoints.down('xs')} {
              min-height: 0;
            }
          }
        }

        .Tiles__Item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          ${theme.breakpoints.down('sm')} {
            height: calc(100% - 16px);
          }

          &:not(.Tiles__Orange_Theme) {
            padding-bottom: 72px;

            ${theme.breakpoints.down('md')} {
              padding-bottom: 64px;
            }

            ${theme.breakpoints.down('sm')} {
              padding-bottom: 24px;
            }
          }
        }
      }

      .Tiles__Dots--Top,
      .Tiles__Dots--Bottom {
        height: 74px;
        width: 74px;
        background-image: radial-gradient(#7f7f7f 1px, transparent 0);
        background-size: 22px 22px;
        position: absolute;
      }

      .Tiles__Item-Title:hover {
        color: ${theme.webMktNewPalette.action.light.primary};
        .InlineStrikethrough {
          color: ${theme.webMktNewPalette.action.light.primary};
        }

        &.Nohover{
          color: ${theme.webMktNewPalette.black};
          .InlineStrikethrough {
            color: ${theme.webMktNewPalette.black};
          }
        }
      }

      .Tiles__Orange_Theme {
        padding-bottom: 24px;
        .Tiles__Item-Title:hover {
          color: ${theme.webMktNewPalette.white};
          opacity: 0.8;
        }
      }

      .Tiles__Card-Link {
        cursor: pointer;
        position:relative;
        a.divAnchor{position:absolute; left;0; top:0; width:100%; height:100%;z-index:1;}

        &:hover .Tiles__Item-Title {
          color: ${theme.webMktNewPalette.black};
        }

        .Tiles__Item-Title {
        .Tiles__Item-Text{
          color: ${theme.webMktNewPalette.action.light.primary};

          &:hover {
            color: ${theme.webMktNewPalette.action.light.primary};
          }
  }
        }

        ${theme.breakpoints.down('xs')} {
          max-width: 328px;
          width: 100%;
        }

        &:hover {
          .Tiles__Item {
            box-shadow: 0px 16px 16px -8px ${theme.webMktNewPalette.alphaBlack[10]};
          }
        }

        &.Tiles__Card-Nohover {
          .Tiles__Item-Title.Nohover {
            color: ${theme.webMktNewPalette.black};
          }
        }

        &.Tiles__Card-Nohover:hover{
          cursor: default;
          .Tiles__Item {
            box-shadow: none;
          }
        }
      }

      .Tiles__Dots--Top {
        top: -10px;
        right: -17px;
        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 0;
          border-bottom: 66px solid ${theme.webMktNewPalette.white};
          border-right: 66px solid transparent;
        }
      }

      .Tiles__Dots--Bottom {
        bottom: -17px;
        left: -10px;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 0;
          height: 0;
          border-top: 66px solid ${theme.webMktNewPalette.white};
          border-left: 66px solid transparent;
        }
      }
    `
  }}
`

export const TilesContainer = styled.div<{
  $topPadding: string
  $bottomPadding: string
  $theme: string
}>`
  ${({ theme, $topPadding, $bottomPadding, $theme }) => {
    return `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
      background-color: ${
        $theme === 'Grey' ? theme.webMktNewPalette.deepBlue[10] : theme.webMktNewPalette.white
      }      
    `
  }}
`
